import React from "react";
import { AdminActivityContextProvider } from "./AdminActivityView";
import AdminActivity from "./views/AdminActivity";

const AdminActivityPage = () => {
  return (
    <div>
      <AdminActivityContextProvider>
        <AdminActivity />
      </AdminActivityContextProvider>
    </div>
  );
};

export default AdminActivityPage;
